namespace GeniuzPOS.Product {
    export interface CsSizeRow {
        Id?: number;
        SizeId?: string;
        SizeName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsSizeRow {
        export const idProperty = 'SizeId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsSize';
        export const lookupKey = 'Product.CsSize';

        export function getLookup(): Q.Lookup<CsSizeRow> {
            return Q.getLookup<CsSizeRow>('Product.CsSize');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ขนาด:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ขนาด:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ขนาด:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ขนาด:Modify';

        export declare const enum Fields {
            Id = "Id",
            SizeId = "SizeId",
            SizeName = "SizeName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
